<feedback-display-header [title]="'comments' | translate">

  <div header-filters>
    <comment-filter-dropdown></comment-filter-dropdown>
    <marker-filter-dropdown></marker-filter-dropdown>
  </div>

  <div header-menu>
    <button
      type="button"
      id="comment-action-menu-btn"
      [matMenuTriggerFor]="actionMenu"
      class="btn btn-xs menu-btn icon-btn ficon-app-dots-vertical"
      [attr.aria-label]="'session-list-item_view-options' | translate"
    ></button>

    <mat-menu #actionMenu="matMenu" class="action-menu">
      <button
        mat-menu-item
        class="one-click-markers-menu-item"
        (click)="feedbackSessionService.toggleOneClickMarker()"
        [attr.aria-label]="getAriaLabel('one-click-markers')"
        [attr.aria-pressed]="feedbackSessionService.getOneClickMarkerEnabled()"
        >
        <mat-slide-toggle
          [hideIcon]="false"
          color="primary"
          [checked]="feedbackSessionService.getOneClickMarkerEnabled()"
          >
        </mat-slide-toggle>
        <span translate="feedback-session-feedback-display_comment-one-click-markers-label"></span>
      </button>

      @if (feedbackSession.isPlaybackMode()) {
        <button
          mat-menu-item
          class="autoplay-menu-item"
          (click)="feedbackSessionService.toggleAutoPlay()"
          [attr.aria-label]="getAriaLabel('autoplay')"
          [attr.aria-pressed]="feedbackSessionService.getAutoPlayEnabled()"
          >
          <mat-slide-toggle
            color="primary"
            [hideIcon]="false"
            [checked]="feedbackSessionService.getAutoPlayEnabled()"
            >
          </mat-slide-toggle>
          <span translate="feedback-session-feedback-display_comment-autoplay-label"></span>
        </button>
      }

      <button
        mat-menu-item
        class="print-comments-btn"
        (click)="printComments()"
        [attr.aria-label]="'print comments'"
        >
        <i class="ficon-app-print action-menu-icon"></i>
        <span class="action-menu-action" translate="feedback-session-comments-print"></span>
      </button>

      @if (showSyncEventCommentsFilterButton$ | async) {
        <button
          mat-menu-item
          class="sync-event-filter-btn"
          (click)="ngxCommentListService.toggleFilterOutSyncEventComments()"
          [attr.aria-label]="'toggle timing comment'"
          [class.active]="ngxCommentListService.shouldFilterOutSyncEventComments()"
          >
          <span
            class="action-menu-action"
            translate="{{ngxCommentListService.shouldFilterOutSyncEventComments() ? ('feedback-session-feedback-display_show-slide-transitions' | translate) : ('feedback-session-feedback-display_hide-slide-transitions' | translate)}}">
          </span>
        </button>
      }

      @if (showReRunAiFeedbackButton()) {
        <button
          mat-menu-item
          class="rerun-ai-feedback-btn"
          (click)="rerunAiFeedback.emit()"
          [disabled]="rerunningAiFeedback"
          [attr.aria-label]="'feedback-session-rerun-ai-feedback' | translate"
          >
          <span class="action-menu-action rerun-ai-feedback" translate="feedback-session-rerun-ai-feedback"></span>
          @if (rerunningAiFeedback) {
            <i class="ficon-spinner"></i>
          }
        </button>
      }
    </mat-menu>
  </div>

</feedback-display-header>
